<template>
  <div class="table-action-wrapper design-assign" ref="container">
    <p class="item-selected mb-0" v-html="`Selected: ${total} ${total > 1 ? 'items' : 'item'}`"></p>
    <div v-if="total > 0" class="position-relative d-flex w-100 mb-2 align-items-center">
      <p class="mb-0">
        <span>Detected: </span>
        <span v-show="total - errors > 0" class="text-success">{{ total - errors }} successful</span>
        <span v-show="errors > 0 && errors < total"> / </span>
        <span v-show="errors > 0" class="text-danger">{{ errors }} {{ errors > 1 ? 'errors' : 'error' }}</span>
      </p>
    </div>
    <div class="position-relative d-flex w-100">
      <Select source="user/search" type="auto" field="design.designer_read" placeholder="Designer" :value="designerId" @changeValue="handleChangeDesigner" class="flex-1 mr-2"></Select>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center">
        <span>Confirm</span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      ids: {},
      designerId: null
    }
  },
  mounted() {
    let listStatus = this.store.getter('extra_attributes.status', {})
    let status = 'raw'
    this.store.commit('query.status', {
      value: status,
      valueLabel: listStatus?.[status]?.text,
      fieldLabel: 'Status'
    })
    this.store.commit('cols.cb.hidden', false)
    this.$emit('change-filters', { search: '' }, { refresh: true, goToFirst: true })
    this.$emitter.on('table-list.refreshed', this.tableListRefreshed)
  },
  unmounted() {
    this.store.commit('cols.cb.hidden', true)
    this.$emitter.off('table-list.refreshed', this.tableListRefreshed)
  },
  computed: {
    store() {
      return this.config?.store
    },
    cb() {
      return this.config?.cb
    },
    rows() {
      let rows = {}
      Object.entries(this.store.getter('rows', {})).forEach(([indexRow, item]) => {
        rows[item._id] = item
        rows[item._id].indexRow = indexRow
      })
      return rows
    },
    errors() {
      return Object.keys(
        this.$util.filter(this.ids, ({ item: items }) => {
          return (
            Object.keys(
              this.$util.filter(items, ({ item }) => {
                return item.live != true
              })
            ).length > 0
          )
        })
      ).length
    }
  },
  methods: {
    tableListRefreshed(e) {
      Object.entries(this.ids).forEach(([id]) => {
        e.cb[id] = true
      })
    },
    handleChangeDesigner(value) {
      this.designerId = value
    },
    submit() {
      this.$util
        .post(
          'order/more/design-assignment',
          {
            ids: Object.keys(this.ids).join(','),
            designer_id: this.designerId
          },
          this.$refs.container
        )
        .then((response) => {
          if (response?.status == 'success') {
            this.ids = []
            this.$emitter.emit('TableList.Refresh')
          }
        })
    }
  },
  watch: {
    cb: {
      handler(values) {
        Object.entries(values).forEach(([id, checked]) => {
          if (checked) {
            if (this.rows?.[id]?.line_items) {
              this.ids[id] = {}
              let promises = []
              Object.entries(this.rows[id].line_items).forEach(([, lineItem]) => {
                this.ids[id][lineItem.identify] = {
                  thumbnail: lineItem.thumbnail,
                  live: !lineItem.thumbnail ? false : true
                }
                if (lineItem.thumbnail) {
                  promises.push(
                    new Promise((resolve) => {
                      this.$util.storage
                        .ping(lineItem.thumbnail)
                        .then(() => {
                          resolve({
                            id: id,
                            line_item: lineItem,
                            status: 200
                          })
                        })
                        .catch(() => {
                          resolve({
                            id: id,
                            line_item: lineItem,
                            status: 500
                          })
                        })
                    })
                  )
                }
              })
              Promise.all(promises).then((values) => {
                Object.entries(values).forEach(([, value]) => {
                  if (this.ids?.[value.id]?.[value.line_item.identify]) {
                    this.ids[value.id][value.line_item.identify].live = value.status < 400 ? true : false
                  }
                })
              })
            }
          } else if (this.ids[id] != undefined) {
            delete this.ids[id]
          }
        })
        this.total = Object.keys(this.ids).length
      },
      deep: true
    }
  },
  props: {
    config: Object
  }
}
</script>
